import React, { Component } from 'react'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'

class InfoHeader extends Component {
	render() {
		const { header, subheader } = this.props

		return (
			<div className='info-header'>
        <div className='info-header-overlay'></div>
        <div className='info-header-content'>
          <h1>{header}</h1>
          <h2>{subheader}</h2>
        </div>
      </div>
		)
	}
}

function mapStateToProps ({ rfpData, questions }) {
  const { header, subheader, lang } = rfpData

  return {
    header,
    subheader,
    lang
  }
}

export default connect(mapStateToProps)(InfoHeader)


// WEBPACK FOOTER //
// ./src/components/InfoHeader.js